import { Component, Injector, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { filter, first, switchMap, takeUntil } from 'rxjs';
import { BreakpointEnum, BreakpointTypeEnum } from '@shared/types/screen-breakpoints';
import { BaseObject } from '@shared/base/base-object';
import { SettingsService } from '@shared/api/settings.service';
import { UserState } from '@shared/states/user.state';
import { ApiService } from '@shared/api/api.service';
import { UserModel } from '@shared/types/user';
import { CatalogState } from '@shared/states/catalog.state';
import { AppInjector } from '@shared/config/app-injector';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App extends BaseObject {
  protected readonly title = signal('UGOL SKETCH');

  constructor(
    private breakpointObserver: BreakpointObserver,
    private settingsService: SettingsService,
    private userState: UserState,
    private apiService: ApiService,
    private catalogState: CatalogState,
    injector: Injector,
  ) {
    super();

    AppInjector.Injector = injector;

    this.userState.userIsLogin$
      .pipe(
        filter((userIsLogin) => userIsLogin),
        first(),
        switchMap(() => this.apiService.getProfile()),
      )
      .subscribe((user) => this.userState.user$.next(user as unknown as UserModel));

    this.breakpointObserver
      .observe([
        BreakpointEnum.XXSmall,
        BreakpointEnum.XSmall,
        BreakpointEnum.Small,
        BreakpointEnum.HalfSmall,
        BreakpointEnum.Medium,
        BreakpointEnum.Large,
        BreakpointEnum.XLarge,
      ])
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        const breakpoints = result.breakpoints;

        for (const prop in breakpoints) {
          if (breakpoints[prop]) {
            const indexOfBreakpoint = Object.values(BreakpointEnum).indexOf(
              prop as unknown as BreakpointEnum,
            );
            const key = Object.keys(BreakpointEnum)[indexOfBreakpoint];

            this.settingsService.screenBreakpoint$.next(key as unknown as BreakpointTypeEnum);
          }
        }
      });
  }
}
